// extracted by mini-css-extract-plugin
module.exports = {"ClaimPod":"Q05I8IAiYiP+ZdViqx1c2g==","SaveBtn":"_6nhm7vqnRzB3cc1QmKRK3A==","ContactData":"eyLvWSwEdSmikqoLQZqenQ==","errorLabel":"K-jcLHF3rx5gncrbY7+g6A=="};